"use strict";
(self["webpackChunkgrafana"] = self["webpackChunkgrafana"] || []).push([[1717],{

/***/ 45622:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"id":"elasticsearch"}');

/***/ })

}]);